var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvailableUpdateIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 745,
    height: 437,
    viewBox: "0 0 745 437",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-16.8878 434.811C-20.2685 433.286 -22.5037 430.395 -22.7146 426.692C-26.4502 361.093 -58.1268 -247.452 77.3615 156.815C219.162 579.916 628.63 276.584 742.953 494.534C744.783 498.024 744.305 502.432 741.758 505.44L580.186 696.314C577.302 699.721 572.509 700.804 568.44 698.967L-16.8878 434.811Z",
    fill: "#3DA865"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_672)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.2,
    y: 172.933,
    width: 228.8,
    height: 144.733,
    fill: "#9ED4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.8 166H40V310.733H268.8V166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.715 310.733H40V166L216.715 310.733Z",
    fill: "#F2F2F2",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 166.5,
    width: 15.2764,
    height: 143.733,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3113,
    y: 182.374,
    width: 52.9447,
    height: 127.859,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3113,
    y: 181.841,
    width: 15.3409,
    height: 211.989,
    transform: "rotate(-90 56.3113 181.841)",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9123 175.338C49.1644 175.338 49.3688 175.127 49.3688 174.867C49.3688 174.607 49.1644 174.397 48.9123 174.397C48.6601 174.397 48.4557 174.607 48.4557 174.867C48.4557 175.127 48.6601 175.338 48.9123 175.338Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6156 175.338C47.8677 175.338 48.0721 175.127 48.0721 174.867C48.0721 174.607 47.8677 174.397 47.6156 174.397C47.3634 174.397 47.159 174.607 47.159 174.867C47.159 175.127 47.3634 175.338 47.6156 175.338Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6683 171.516C50.6317 171.428 50.5632 171.36 50.4758 171.325C50.435 171.308 50.3923 171.3 50.3484 171.3H48.2083C48.0167 171.3 47.8606 171.459 47.8606 171.654C47.8606 171.849 48.0165 172.008 48.2083 172.008H49.8322L49.5723 172.66C49.3684 173.176 48.8754 173.51 48.317 173.51C47.7564 173.508 47.247 173.155 47.0496 172.631L46.4018 170.897C46.3508 170.76 46.2203 170.669 46.0769 170.669H44.998C44.8065 170.669 44.6504 170.827 44.6504 171.023C44.6504 171.218 44.8063 171.377 44.998 171.377H45.8372L46.3999 172.883C46.6982 173.682 47.4684 174.218 48.3165 174.218C48.5609 174.218 48.8019 174.174 49.0329 174.087C49.5712 173.885 50.0026 173.462 50.2162 172.925L50.67 171.787C50.7052 171.699 50.7045 171.603 50.6683 171.516Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.9058,
    cy: 190.278,
    rx: 4.65041,
    ry: 4.66882,
    fill: "#64B984"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.9058,
    cy: 204.284,
    rx: 4.65041,
    ry: 4.66882,
    fill: "#64B984"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.9058,
    cy: 218.291,
    rx: 4.65041,
    ry: 4.66882,
    fill: "#64B984"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.9058,
    cy: 232.297,
    rx: 4.65041,
    ry: 4.66882,
    fill: "#64B984"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.9058,
    cy: 276.651,
    rx: 4.65041,
    ry: 4.66882,
    fill: "#37975B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8294 192.771C87.6029 192.872 87.253 192.807 87.1087 192.529L86.8686 192.063H84.7682L84.5211 192.529C84.3769 192.801 84.0406 192.86 83.8005 192.771C83.5259 192.671 83.4025 192.388 83.5259 192.152L85.3035 188.735C85.3586 188.623 85.4683 188.534 85.5917 188.487C85.729 188.44 85.9005 188.44 86.0378 188.487C86.1682 188.535 86.2644 188.623 86.3261 188.735L88.1037 192.152C88.2277 192.388 88.0973 192.653 87.8294 192.771ZM86.3744 191.125L85.8183 190.051L85.2624 191.125H86.3744Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3236 191.326C88.3236 190.494 89.1129 189.815 90.0807 189.815C90.3894 189.815 90.6846 189.886 90.9386 190.004C91.0348 189.915 91.1652 189.862 91.3161 189.862C91.6043 189.862 91.8378 190.063 91.8378 190.305V193.29C91.8378 193.532 91.6043 193.727 91.3297 193.739H91.2816C90.9795 193.739 90.7463 193.527 90.7463 193.273V192.724C90.5404 192.795 90.3138 192.836 90.0807 192.836C89.1129 192.836 88.3236 192.158 88.3236 191.326ZM89.415 191.326C89.415 191.644 89.7102 191.898 90.0809 191.898C90.4517 191.898 90.7466 191.644 90.7466 191.326C90.7466 191.007 90.4514 190.753 90.0809 190.753C89.7102 190.753 89.415 191.007 89.415 191.326Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9039 192.86C93.0665 192.86 92.3869 192.276 92.3869 191.556V190.329C92.3869 190.075 92.6271 189.862 92.9361 189.862C93.2382 189.862 93.4784 190.075 93.4784 190.329V191.556C93.4784 191.757 93.6707 191.922 93.9039 191.922C94.1374 191.922 94.3294 191.757 94.3294 191.556V190.329C94.3294 190.075 94.5696 189.862 94.8717 189.862C95.1805 189.862 95.4209 190.075 95.4209 190.329V191.556C95.4206 192.276 94.7411 192.86 93.9039 192.86Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4501 192.813C96.148 192.813 95.9009 192.6 95.9009 192.34V190.299C95.9009 190.039 96.148 189.826 96.4501 189.826C96.7522 189.826 96.9993 190.039 96.9993 190.299V192.34C96.9993 192.6 96.7522 192.813 96.4501 192.813Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.751 193.606C101.038 193.606 101.27 193.385 101.27 193.114C101.27 192.842 101.038 192.621 100.751 192.621C100.464 192.621 100.231 192.842 100.231 193.114C100.231 193.385 100.464 193.606 100.751 193.606Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2751 193.606C99.562 193.606 99.7946 193.385 99.7946 193.114C99.7946 192.842 99.562 192.621 99.2751 192.621C98.9882 192.621 98.7556 192.842 98.7556 193.114C98.7556 193.385 98.9882 193.606 99.2751 193.606Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.749 189.608C102.707 189.515 102.629 189.445 102.53 189.408C102.483 189.391 102.435 189.382 102.385 189.382H99.9496C99.7316 189.382 99.554 189.548 99.554 189.752C99.554 189.956 99.7313 190.123 99.9496 190.123H101.797L101.502 190.804C101.27 191.345 100.709 191.694 100.073 191.694C99.4354 191.692 98.8557 191.322 98.6311 190.775L97.8938 188.96C97.8359 188.817 97.6874 188.722 97.5241 188.722H96.2965C96.0785 188.722 95.9009 188.888 95.9009 189.092C95.9009 189.296 96.0782 189.462 96.2965 189.462H97.2514L97.8917 191.038C98.2312 191.873 99.1076 192.435 100.073 192.435C100.351 192.435 100.625 192.389 100.888 192.298C101.5 192.086 101.991 191.643 102.234 191.082L102.751 189.892C102.791 189.8 102.79 189.699 102.749 189.608Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3678 192.848C63.947 192.848 62.7869 191.851 62.7869 190.629C62.7869 189.408 63.947 188.41 65.3678 188.41C65.9375 188.41 66.4798 188.564 66.9397 188.871C67.1799 189.03 67.2213 189.319 67.0428 189.532C66.8505 189.738 66.5142 189.774 66.2741 189.614C66.0134 189.443 65.6976 189.349 65.368 189.349C64.5445 189.349 63.8786 189.927 63.8786 190.629C63.8786 191.332 64.5445 191.91 65.368 191.91C65.6907 191.91 66.0064 191.816 66.2671 191.645C66.5142 191.491 66.8505 191.526 67.0359 191.733C67.2213 191.94 67.1732 192.235 66.9328 192.394C66.4795 192.695 65.9375 192.848 65.3678 192.848Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1126 191.349C71.1126 192.181 70.3233 192.86 69.3555 192.86C68.3878 192.86 67.5985 192.181 67.5985 191.349C67.5985 190.517 68.3878 189.838 69.3555 189.838C70.3233 189.838 71.1126 190.517 71.1126 191.349ZM68.6896 191.349C68.6896 191.668 68.9848 191.922 69.3555 191.922C69.7263 191.922 70.0215 191.668 70.0215 191.349C70.0215 191.031 69.7263 190.777 69.3555 190.777C68.9848 190.777 68.6896 191.031 68.6896 191.349Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5557 191.131V192.34C76.5557 192.6 76.3017 192.813 76.0065 192.813C75.7113 192.813 75.4573 192.6 75.4573 192.34V191.131C75.4573 190.93 75.2719 190.771 75.0387 190.771C74.8122 190.771 74.6202 190.93 74.6202 191.131V192.34C74.6202 192.6 74.3731 192.813 74.071 192.813C73.7758 192.813 73.5218 192.6 73.5218 192.34V191.131C73.5218 190.93 73.3297 190.771 73.1032 190.771C72.8697 190.771 72.6844 190.93 72.6844 191.131V192.34C72.6844 192.6 72.4373 192.813 72.1352 192.813C71.84 192.813 71.5929 192.6 71.5929 192.34V190.31C71.5929 190.057 71.8264 189.862 72.1077 189.862C72.238 189.862 72.3478 189.903 72.4373 189.968C72.6363 189.88 72.8628 189.833 73.1032 189.833C73.467 189.833 73.8103 189.95 74.071 190.133C74.3319 189.95 74.6749 189.833 75.0387 189.833C75.8692 189.833 76.5557 190.417 76.5557 191.131Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7931 192.836C78.5596 192.836 78.3331 192.795 78.1272 192.724V193.273C78.1272 193.527 77.887 193.739 77.5849 193.739H77.5368C77.2622 193.728 77.0357 193.533 77.0357 193.291V190.305C77.0357 190.063 77.2692 189.862 77.5504 189.862C77.7083 189.862 77.8387 189.915 77.9348 190.004C78.1889 189.886 78.484 189.815 78.7928 189.815C79.7606 189.815 80.5499 190.494 80.5499 191.326C80.5504 192.158 79.7611 192.836 78.7931 192.836ZM78.7931 190.753C78.4223 190.753 78.1272 191.007 78.1272 191.326C78.1272 191.644 78.4223 191.898 78.7931 191.898C79.1638 191.898 79.459 191.644 79.459 191.326C79.459 191.007 79.1638 190.753 78.7931 190.753Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.028 190.334C83.0143 190.594 82.7534 190.777 82.4512 190.783C82.2111 190.788 82.0118 190.942 82.0118 191.143V192.347C82.0118 192.606 81.7717 192.813 81.4696 192.813C81.1675 192.813 80.9273 192.606 80.9273 192.347V190.305C80.9273 190.063 81.1539 189.862 81.4421 189.862C81.5724 189.862 81.6892 189.903 81.7853 189.974C82.0669 189.85 82.3757 189.844 82.513 189.844C82.8153 189.85 83.0418 190.074 83.028 190.334Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5601 193.6C71.9474 193.334 71.7828 193.447 72.1702 193.181C72.6945 193.795 73.3332 194.145 74.1556 194.127C74.9562 194.109 75.5992 193.771 76.1524 193.201C76.3182 193.389 76.4732 193.564 76.6508 193.765C76.0666 194.477 75.2559 194.905 74.2425 194.944C73.0971 194.988 72.1897 194.537 71.5601 193.6Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.9495,
    cy: 204.051,
    rx: 3.4878,
    ry: 3.50161,
    fill: "#8BCBA3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.406,
    cy: 174.17,
    rx: 3.4878,
    ry: 3.50161,
    fill: "#50B174"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.455,
    cy: 174.17,
    rx: 3.4878,
    ry: 3.50161,
    fill: "#64B984"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.504,
    cy: 174.17,
    rx: 3.4878,
    ry: 3.50161,
    fill: "#8BCBA3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.7627,
    y: 203.351,
    width: 12.0911,
    height: 1.86753,
    rx: 0.933763,
    fill: "#50B174"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.406,
    y: 190.745,
    width: 40.4585,
    height: 1.86753,
    rx: 0.933763,
    fill: "#50B174"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.406,
    y: 197.281,
    width: 17.6715,
    height: 1.86753,
    rx: 0.933763,
    fill: "#B1DCC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.057,
    y: 222.96,
    width: 17.6715,
    height: 0.933763,
    rx: 0.466882,
    fill: "#8BCBA3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.406,
    y: 266.38,
    width: 32.5528,
    height: 0.933763,
    rx: 0.466882,
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.522,
    y: 225.761,
    width: 6.51057,
    height: 0.466882,
    rx: 0.233441,
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.218,
    y: 225.761,
    width: 6.51057,
    height: 0.466882,
    rx: 0.233441,
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.057,
    y: 231.83,
    width: 17.6715,
    height: 0.933763,
    rx: 0.466882,
    fill: "#8BCBA3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.522,
    y: 234.632,
    width: 6.51057,
    height: 0.466882,
    rx: 0.233441,
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.218,
    y: 234.632,
    width: 6.51057,
    height: 0.466882,
    rx: 0.233441,
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.057,
    y: 240.701,
    width: 17.6715,
    height: 0.933763,
    rx: 0.466882,
    fill: "#9ED4B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.522,
    y: 243.502,
    width: 6.51057,
    height: 0.466882,
    rx: 0.233441,
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.218,
    y: 243.502,
    width: 6.51057,
    height: 0.466882,
    rx: 0.233441,
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.097,
    y: 214.339,
    width: 17.1715,
    height: 3.70194,
    rx: 1.85097,
    stroke: "#37975B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.844,
    y: 214.089,
    width: 17.6715,
    height: 4.20194,
    rx: 2.10097,
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.091,
    y: 214.339,
    width: 17.1715,
    height: 3.70194,
    rx: 1.85097,
    stroke: "#37975B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.087,
    y: 214.339,
    width: 17.1715,
    height: 3.70194,
    rx: 1.85097,
    stroke: "#37975B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.9495,
    cy: 213.855,
    rx: 3.4878,
    ry: 3.50161,
    fill: "#8BCBA3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.7627,
    y: 213.155,
    width: 22.322,
    height: 1.86753,
    rx: 0.933763,
    fill: "#50B174"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.9495,
    cy: 223.66,
    rx: 3.4878,
    ry: 3.50161,
    fill: "#8BCBA3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.7627,
    y: 222.96,
    width: 27.4374,
    height: 1.86753,
    rx: 0.933763,
    fill: "#50B174"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.9495,
    cy: 233.464,
    rx: 3.4878,
    ry: 3.50161,
    fill: "#8BCBA3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.7627,
    y: 232.764,
    width: 14.8813,
    height: 1.86753,
    rx: 0.933763,
    fill: "#50B174"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.9495,
    cy: 243.269,
    rx: 3.4878,
    ry: 3.50161,
    fill: "#8BCBA3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.7627,
    y: 242.569,
    width: 22.322,
    height: 1.86753,
    rx: 0.933763,
    fill: "#50B174"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.9495,
    cy: 253.073,
    rx: 3.4878,
    ry: 3.50161,
    fill: "#8BCBA3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.7627,
    y: 252.373,
    width: 22.322,
    height: 1.86753,
    rx: 0.933763,
    fill: "#50B174"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.9495,
    cy: 263.812,
    rx: 3.4878,
    ry: 3.50161,
    fill: "#8BCBA3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.7627,
    y: 263.111,
    width: 27.4374,
    height: 1.86753,
    rx: 0.933763,
    fill: "#50B174"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.872,
    y: 169.768,
    width: 29.2276,
    height: 8.80452,
    rx: 1.5,
    stroke: "#3DA865"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.32,
    y: 169.768,
    width: 29.2276,
    height: 8.80452,
    rx: 1.5,
    stroke: "#3DA865"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.967,
    cy: 174.233,
    r: 3.03333,
    fill: "#64B984"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.906,
    y: 209.453,
    width: 148.743,
    height: 44.2875,
    rx: 3.5,
    stroke: "#CACECC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.68,
    y: 223.426,
    width: 103.239,
    height: 22.4103,
    rx: 4,
    fill: "#B1DCC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.406,
    y: 271.048,
    width: 47.4341,
    height: 32.2148,
    rx: 4,
    fill: "#64B984"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.561,
    y: 271.048,
    width: 47.4341,
    height: 32.2148,
    rx: 4,
    fill: "#64B984"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.715,
    y: 271.048,
    width: 47.4341,
    height: 32.2148,
    rx: 4,
    fill: "#64B984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8426 440.687C31.5566 440.158 32.1496 439.483 32.5822 438.707C33.0148 437.931 33.2771 437.072 33.3516 436.187C33.4261 435.301 33.3112 434.41 33.0145 433.573C32.7177 432.735 32.246 431.971 31.6306 431.329C31.3698 431.047 31.087 430.785 30.7849 430.547L39.7385 408.771L26.7917 411.161L20.2741 431.474C19.3285 432.657 18.8445 434.142 18.912 435.655C18.9795 437.167 19.5939 438.604 20.6412 439.699C21.9264 441.082 23.6746 441.947 25.5547 442.129C27.4348 442.311 29.3162 441.798 30.8426 440.687Z",
    fill: "#FEE9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8823 428.649L33.9712 428.432C42.9245 406.54 52.1796 383.909 63.1666 359.361L63.2387 359.2L63.0632 359.082C58.6288 356.102 51.5651 355.554 46.6326 357.808C42.0692 359.892 39.397 364.549 40.1205 369.145L31.0166 397.805C27.5518 407.124 23.9659 416.77 20.5083 426.29L20.4102 426.559L20.79 426.621C25.2555 427.337 29.8689 428.079 33.5719 428.605L33.8823 428.649Z",
    fill: "#D8EEE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1971 336.595C46.4746 336.595 38.593 329.38 38.593 320.479C38.593 311.579 46.4746 304.364 56.1971 304.364C65.9196 304.364 73.8013 311.579 73.8013 320.479C73.8013 329.38 65.9196 336.595 56.1971 336.595Z",
    fill: "#FEE9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2932 317.492C48.1931 310.992 51.1647 304.555 55.7593 301.319C57.9804 299.741 60.6479 298.914 63.3727 298.959C66.0975 299.003 68.7369 299.915 70.9057 301.564C75.4292 304.948 78.2614 311.479 78.0218 317.973C67.8864 318 57.751 318.026 48.2932 317.492Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.507 541.368L89.8595 541.336C97.5042 540.649 105.409 539.94 112.88 539.859L113.286 539.854L113.231 539.486C111.461 527.75 110.711 515.55 109.985 503.751C109.268 492.1 108.528 480.054 106.802 468.612C106.072 465.548 105.36 462.521 104.651 459.505C98.7842 434.543 93.2425 410.965 81.8035 387.627L81.6954 387.406L81.4334 387.435C70.7005 388.624 60.3873 392.209 52.394 397.529L52.2391 397.631L52.2467 397.807C52.4669 401.398 52.4928 404.999 52.3242 408.593C48.7274 413.069 46.3193 418.379 45.3228 424.031C44.3263 429.684 44.7736 435.496 46.6232 440.93C43.4759 450.559 40.222 460.513 36.9019 470.331C28.8395 490.566 20.4968 511.505 11.9448 532.731L11.8044 533.079L12.199 533.164C18.3521 534.486 24.6995 535.85 30.9612 536.379L31.1977 536.399L31.31 536.207C47.1904 509.198 60.1845 480.595 70.0781 450.872C72.2151 456.838 75.2934 462.223 78.2758 467.439C81.1161 472.16 83.6264 477.071 85.7889 482.138C87.1088 492.059 87.459 502.809 87.7972 513.204C88.1173 523.033 88.4195 532.316 89.4682 541.045L89.507 541.368Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2069 301.617C54.5763 300.112 46.1359 301.543 40.1433 306.256C34.1507 310.969 31.1077 319.123 33.5695 326.115C36.0314 333.108 44.3895 338.028 51.9468 336.222C49.782 330.637 52.2182 323.779 57.5103 320.562C63.7863 316.747 65.514 307.638 62.2069 301.617Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9426 398.229L53.2217 398.113C62.9561 394.047 72.5012 390.928 81.4443 388.081L81.7185 388.027L81.7192 387.299L81.5413 387.356C81.5038 387.281 81.4617 387.195 81.4193 387.109C81.2972 386.862 81.2139 386.693 81.143 386.582L81.1449 386.581C80.3993 385.19 79.8066 383.846 79.2335 382.546C78.6421 381.205 78.0315 379.82 77.2427 378.354C79.1294 376.689 80.4415 374.471 80.9919 372.017C81.5423 369.563 81.3029 366.998 80.3078 364.688C78.3321 360.401 73.2949 357.063 68.0023 356.509C66.0629 351.622 61.7415 341.352 61.7415 341.352C61.7415 341.352 52.6544 341.124 48.9999 340.699L48.9385 340.692L38.1454 371.096L38.3057 370.186C36.9902 377.187 38.3057 380.059 38.3057 380.059C40.8574 383.767 43.6616 387.294 46.6985 390.616C48.9247 393.164 51.0274 395.571 52.7737 397.995L52.9426 398.229Z",
    fill: "#D8EEE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3224 311.167C40.664 310.437 44.858 305.438 44.2508 300.525C43.6436 295.613 38.3357 291.598 32.951 291.979C27.5663 292.36 22.9954 297.074 23.2202 302.014C23.4451 306.953 28.5024 312.098 35.3224 311.167Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1564 307.981C41.4979 307.251 45.6919 302.253 45.0847 297.34C44.6692 293.979 42.0532 291.041 38.7186 289.641C43.0263 290.504 46.7336 293.94 47.2349 297.996C47.8421 302.909 43.6482 307.907 38.3067 308.637C36.3223 308.924 34.2972 308.665 32.4495 307.887C33.6716 308.122 34.924 308.153 36.1564 307.981Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.17 291.195C122.362 291.717 120.811 292.889 119.815 294.487C118.82 296.086 118.451 297.996 118.78 299.849C118.847 300.228 118.944 300.602 119.07 300.966L100.742 318.029L112.475 321.321L128.081 304.612C129.482 303.836 130.607 302.642 131.302 301.198C131.996 299.753 132.225 298.129 131.957 296.549C131.842 295.664 131.542 294.814 131.077 294.053C130.612 293.292 129.992 292.638 129.258 292.133C128.523 291.628 127.69 291.283 126.814 291.122C125.937 290.96 125.036 290.985 124.17 291.195Z",
    fill: "#FEE9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.103 312.866L122.914 313.027C103.895 329.237 84.235 345.994 63.2426 364.977L63.1051 365.102L62.9238 364.999C58.3441 362.395 55.3016 356.599 55.8463 351.518C56.3503 346.817 60.1254 342.715 65.0347 341.528L90.8553 322.533C99.0732 315.927 107.58 309.09 116.003 302.412L116.241 302.223L116.437 302.522C118.736 306.04 121.111 309.675 122.949 312.619L123.103 312.866Z",
    fill: "#D8EEE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.794 359.055H149.602V390.297H153.794V359.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.844 372.93L165.773 375.787L151.702 360.662L137.627 375.787L134.557 372.93L151.702 354.514L168.844 372.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.537 406C143.904 406 137.42 404.035 131.905 400.354C126.39 396.673 122.091 391.441 119.553 385.32C117.015 379.199 116.35 372.463 117.644 365.964C118.938 359.466 122.133 353.497 126.823 348.812C131.513 344.127 137.489 340.936 143.995 339.644C150.5 338.351 157.243 339.015 163.372 341.55C169.5 344.086 174.738 348.379 178.423 353.888C182.108 359.397 184.075 365.874 184.075 372.5C184.065 381.382 180.528 389.897 174.241 396.177C167.953 402.457 159.429 405.99 150.537 406ZM150.537 343.188C144.733 343.188 139.06 344.907 134.234 348.128C129.408 351.349 125.647 355.927 123.426 361.283C121.205 366.639 120.624 372.533 121.756 378.219C122.888 383.905 125.683 389.128 129.787 393.227C133.891 397.327 139.12 400.118 144.812 401.249C150.505 402.38 156.405 401.8 161.767 399.581C167.129 397.363 171.712 393.606 174.937 388.785C178.161 383.965 179.882 378.298 179.882 372.5C179.874 364.729 176.779 357.278 171.278 351.783C165.776 346.287 158.317 343.196 150.537 343.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.068 332.578H227.693V342.825H229.068V332.578Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.004 337.129L232.997 338.066L228.382 333.105L223.766 338.066L222.759 337.129L228.382 331.089L234.004 337.129Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 347.975C225.824 347.975 223.698 347.331 221.889 346.124C220.08 344.916 218.67 343.2 217.837 341.193C217.005 339.185 216.787 336.976 217.211 334.844C217.636 332.713 218.683 330.755 220.222 329.218C221.76 327.682 223.72 326.635 225.854 326.211C227.988 325.787 230.2 326.005 232.21 326.836C234.22 327.668 235.937 329.076 237.146 330.883C238.355 332.69 239 334.815 239 336.988C238.997 339.901 237.837 342.694 235.775 344.754C233.712 346.814 230.916 347.972 228 347.975ZM228 327.374C226.096 327.374 224.235 327.937 222.653 328.994C221.07 330.05 219.836 331.552 219.108 333.309C218.379 335.065 218.189 336.998 218.56 338.863C218.931 340.728 219.848 342.442 221.194 343.786C222.54 345.131 224.255 346.046 226.122 346.417C227.989 346.788 229.925 346.598 231.683 345.87C233.442 345.143 234.945 343.91 236.003 342.329C237.06 340.748 237.625 338.889 237.625 336.988C237.622 334.439 236.607 331.995 234.803 330.193C232.998 328.39 230.552 327.376 228 327.374Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4583 92.9663H92.3298V116.281H95.4583V92.9663Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.689 103.321L104.398 105.453L93.8971 94.1659L83.3936 105.453L81.1021 103.321L93.8971 89.5777L106.689 103.321Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0279 128C88.0778 128 83.239 126.534 79.1231 123.787C75.0073 121.04 71.7994 117.135 69.9051 112.567C68.0108 107.999 67.5152 102.972 68.4809 98.1227C69.4466 93.2732 71.8303 88.8186 75.3305 85.3223C78.8307 81.826 83.2903 79.445 88.1452 78.4804C93.0001 77.5157 98.0324 78.0108 102.606 79.903C107.179 81.7952 111.088 84.9995 113.838 89.1107C116.588 93.222 118.056 98.0555 118.056 103C118.048 109.628 115.409 115.983 110.717 120.669C106.025 125.356 99.6634 127.993 93.0279 128ZM93.0279 81.1251C88.6966 81.1251 84.4626 82.408 80.8612 84.8117C77.2599 87.2153 74.453 90.6317 72.7955 94.6289C71.138 98.626 70.7043 103.024 71.5493 107.268C72.3943 111.511 74.48 115.409 77.5427 118.468C80.6054 121.527 84.5075 123.611 88.7555 124.455C93.0036 125.299 97.4068 124.866 101.408 123.21C105.41 121.554 108.83 118.75 111.237 115.153C113.643 111.556 114.927 107.327 114.927 103C114.921 97.2005 112.611 91.6403 108.506 87.5394C104.4 83.4384 98.8339 81.1316 93.0279 81.1251Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.573 131.578H151.571V146.5H153.573V131.578Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.761 138.205L159.295 139.57L152.574 132.346L145.852 139.57L144.385 138.205L152.574 129.41L160.761 138.205Z",
    fill: "#3DA865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.018 154C148.85 154 145.753 153.062 143.119 151.304C140.485 149.545 138.432 147.047 137.219 144.123C136.007 141.199 135.69 137.982 136.308 134.879C136.926 131.775 138.451 128.924 140.692 126.686C142.932 124.449 145.786 122.925 148.893 122.307C152 121.69 155.221 122.007 158.148 123.218C161.074 124.429 163.576 126.48 165.336 129.111C167.096 131.742 168.036 134.836 168.036 138C168.031 142.242 166.342 146.309 163.339 149.308C160.336 152.308 156.265 153.995 152.018 154ZM152.018 124C149.246 124 146.536 124.821 144.231 126.359C141.926 127.898 140.13 130.084 139.069 132.642C138.008 135.201 137.731 138.016 138.272 140.731C138.812 143.447 140.147 145.942 142.107 147.9C144.067 149.857 146.565 151.191 149.284 151.731C152.002 152.271 154.82 151.994 157.381 150.934C159.942 149.875 162.131 148.08 163.671 145.778C165.211 143.476 166.033 140.769 166.033 138C166.029 134.288 164.551 130.73 161.924 128.105C159.296 125.481 155.734 124.004 152.018 124Z",
    fill: "#3DA865"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 290,
    height: 432,
    fill: "white",
    transform: "translate(-1 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableUpdateIllustration);
export default __webpack_public_path__ + "static/media/available-update-illustration.a3febc355534271868ab671ea66ec03e.svg";
export { ForwardRef as ReactComponent };